/**
 * Gamification API — daraja, yutuqlar.
 */
import { apiClient } from "./apiClient";

export interface UserLevelData {
  level: number;
  xp: number;
  xp_for_next_level: number;
  total_xp_earned: number;
}

export const gamificationApi = {
  getMyLevel: () =>
    apiClient.get<{ data: UserLevelData }>("/gamification/level/me/").then((r) => r.data.data),

  getStreak: () =>
    apiClient.get<{
      success: boolean;
      current_streak: number;
      longest_streak: number;
      level: number;
      total_xp: number;
    }>("/gamification/streak/").then((r) => r.data),

  getAchievements: () =>
    apiClient.get("/gamification/achievements/").then((r) => r.data),
};
